// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27pHj","rootNoMargin":"styles_rootNoMargin__jTBwe"};